<template>
  <div class="ModelContainer" @click="showOperEquipment()">
    <div class="ModelDiv">
      <img :src="require('./img/'+OperImage)" style="width:120px;height:60px;" />
      <br/>
      <span>{{OperTitle}}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OperModel',
  data() {
    return {
    }
  },
  props: ['OperName', 'OperTitle', 'OperImage'],
  mounted() {
  },
  methods: {
    showOperEquipment() {
      let operAttr = {
        OperLabel: this.OperTitle
      }
      this.$root.$children[0].$children[0].showOperEquipment(this.OperName, undefined, undefined, operAttr)
    }
  }
};

</script>

<style lang="less" scoped>
.ModelContainer {
  width:170px;
  height:100px;
}
.ModelDiv {
  background-color: #E1E1E1;
  color: #000;
  width:150px;
  height:100px;
  border:2px solid #ffffff;
  border-radius:15px;
  text-align: center;
  cursor: pointer;
}
</style>

